export interface GetCompanyPoListPagingAndFilterResponse {
    isSuccess: boolean
    message: any
    data: GetCompanyPoListPagingAndFilterResponseData
}

export interface GetCompanyPoListPagingAndFilterResponseData {
    items: GetCompanyPoListPagingAndFilterResponseItem[]
    totalRecordCount: number
}

export interface GetCompanyPoListPagingAndFilterResponseItem {
    companyPoId: string
    companyId: string
    projectId: string
    projectName: string
    projectKey: string
    senderCode: string
    customerId: string
    divisionId: string
    poId: any
    poNo: string
    startDate: string
    endDate: string
    isCustomActive: boolean
    isSenderReceiverUnregistered: boolean
    matchReceiverCustomerName?: string
    matchArrivalUnitName?: string
    matchSenderCustomerName?: string
    matchDeliverer?: string
    matchDeliveryReceiver?: string
    customerName: string
    divisionName: string
    poName: any
    createdDate: string
    createdUser: string
    updatedDate: string
    updatedUser: string
    isSelected: boolean
}

export const initialGetCompanyPoListPagingAndFilterResponseData: GetCompanyPoListPagingAndFilterResponseData = {
    items: [],
    totalRecordCount: 0
}